module.exports = __webpack_public_path__ + "media/images/tick_small-db64f24e4c9d03e167359969e3e5111b.png";